import { useHeapGauge } from '../hooks/performance/use-heap-gauge';
import { useSessionStartHeap } from '../hooks/performance/use-session-start-heap';
import { useSessionStartTime } from '../hooks/performance/use-session-start-time';

/**
 * Renders nothing. Initializes performance instrumentation once atoms
 * and providers (Analytics, Metrics, StudioAtomHydrator) are available.
 */
export function PerformanceInitializer() {
  useSessionStartTime();
  useSessionStartHeap();
  useHeapGauge();
  return null;
}